"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexGrid = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = require("./Flex.styled");
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _FlexContants = require("./FlexContants");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * This is the used to create a Flex grid.
 *
 * @param children The content inside the Flex Grid.
 * @param flexType The type of the Grid
 * @returns {JSX.Element} The Grid
 */
var FlexGrid = function FlexGrid(_ref) {
  var children = _ref.children,
    _ref$flexType = _ref.flexType,
    flexType = _ref$flexType === void 0 ? _FlexContants.FLEX_GRID_TYPES.SECTIONS : _ref$flexType;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.GridContainer, {
    flexType: flexType,
    children: children
  });
};
exports.FlexGrid = FlexGrid;
FlexGrid.prototype = {
  children: PropTypes.node.isRequired,
  flexType: PropTypes.oneOf(Object.keys(_FlexContants.FLEX_GRID_TYPES))
};